<template>
  <div class="widget-time" :style="styleColor">
		<TagDateRange size="small" v-model="dateRange"  @change="onChange"></TagDateRange>
  </div>
</template>
<script>
import moment from 'moment';
import TagDateRange from "@/components/TagDateRange";

export default {
  name: "WidgetTime",
  components: {
    TagDateRange
  },
  props: {
    value: Object,
    ispreview: Boolean
  },
  data() {
    return {
      options: {
      },
      dateRange: [],
      timeSelector: ''
    };
  },
  computed: {
    transStyle() {
      return this.$objToOne(this.options);
    },
    styleColor() {
      return {
        position: this.ispreview ? "absolute" : "static",
        color: this.transStyle.color || "#fff",
        value: this.transStyle.value || [],
        timeSelector: this.transStyle.timeSelector,
        "font-size": this.transStyle.fontSize + "px" || "30px",
        "letter-spacing": this.transStyle.letterSpacing + "em",
        background: this.transStyle.background,
        "font-weight": this.transStyle.fontWeight,
        "text-align": this.transStyle.textAlign,
        display:
          this.transStyle.hideLayer == undefined
            ? "block"
            : this.transStyle.hideLayer
            ? "none"
            : "block",
        width: this.transStyle.width + "px",
        height: this.transStyle.height + "px",
        left: this.transStyle.left + "px",
        top: this.transStyle.top + "px",
        right: this.transStyle.right + "px"
      };
    }
  },
  watch: {
    value: {
      handler(val) {
        this.options = val;
      },
      deep: true
    },
    'styleColor.value': {
      handler(val) {
        let value = val.map(v => v.format?v.format('YYYY-MM-DD'):moment(v).format('YYYY-MM-DD'))
        this.dateRange = value

        this.$emit('change', {
          from: value[0],
          to: value[1],
          timeSelector: this.styleColor.timeSelector || undefined,
        })
      },
      'styleColor.timeSelector': {
        handler(val) {
          this.timeSelector = val
        }
      }
    }
  },
  mounted() {
    this.options = this.value;
    this.timeSelector = this.transStyle.timeSelector
  },
  methods: {
    disabledDate(current) {
      return current && current > moment().endOf('day');
    },
    onChange(val, timeSelector) {
      this.$emit('change', {
        from: val[0],
        to: val[1],
        timeSelector: timeSelector || undefined
      })
    },
    formatFunction(date, fmt) {
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      const o = {
        "M+": date.getMonth() + 1, // 月份
        "d+": date.getDate(), // 日
        "h+": date.getHours(), // 小时
        "m+": date.getMinutes(), // 分
        "s+": date.getSeconds(), // 秒
        "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
        S: date.getMilliseconds() // 毫秒
      };
      for (let k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    },
    check(val) {
      if (val < 10) {
        return "0" + val;
      } else {
        return val;
      }
    },
    formatWeek(date, fmt) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      let dayCycle = date.getDay();
      const dayCycleArray = ["日", "一", "二", "三", "四", "五", "六"];
      for (let i = 0; i < 7; i++) {
        if (dayCycle == i) {
          dayCycle = " 星期" + dayCycleArray[i];
        }
      }
      if (fmt == "year-week") {
        return year + "-" + month + "-" + day + dayCycle;
      } else if (fmt == "year-h-m-week") {
        return (
          year +
          "-" +
          month +
          "-" +
          day +
          " " +
          hours +
          ":" +
          minutes +
          dayCycle
        );
      } else if (fmt == "year-h-m-s-week") {
        return (
          year +
          "-" +
          month +
          "-" +
          day +
          " " +
          hours +
          ":" +
          minutes +
          ":" +
          seconds +
          dayCycle
        );
      } else if (fmt == "week") {
        return dayCycle;
      }
    },
  }
};
</script>
<style lang="less" scoped>
.widget-time {
  width: 100%;
  height: 100%;
  overflow: hidden;
  /deep/ .ant-calendar-picker {
    width: 100%;
    height: 100%;
    vertical-align: top;
    font-size: inherit;
    .ant-calendar-picker-input {
      height: 100%;
      font-size: inherit;
      .ant-calendar-range-picker-separator {
        vertical-align: inherit;
      }
    }
  }
}
</style>